/* BG CC presale hero — "N min read" counted from the words in #MainContent (as live Ella cc-presale-hero). */
if (!customElements.get('bg-ccp-readtime')) {
  customElements.define(
    'bg-ccp-readtime',
    class BgCcpReadtime extends HTMLElement {
      connectedCallback() {
        const main = document.getElementById('MainContent');
        if (!main) return;
        let wpm = parseInt(this.dataset.wpm, 10);
        if (!wpm || wpm < 1) wpm = 200;
        const words = (main.innerText || '').trim().split(/\s+/).filter((w) => w.length > 0).length;
        this.textContent = `${Math.max(1, Math.ceil(words / wpm))} ${this.dataset.suffix || 'min read'}`;
      }
    }
  );
}
